import React, { ReactElement } from 'react';
import { Loader } from 'idsk-react-components';
import LegislativnyMaterialDetail from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import useObalMaterialuNrSrZaBezchybnostInitData from './hook/useObalMaterialuNrSrZaBezchybnostInitData';
import { useClient } from '../../../context/ClientStatusContext';
import {
  fetchObalMaterialuNrSrZaBezchybnostInitData,
} from '../../../client/pracovnyKrok/sprievodnyDokument/obalMaterialuInitDataClient';
import ObalMaterialuNrSrBezchybnost from './ObalMaterialuNrSrBezchybnost';
import {
  createObalMaterialuNrSrBezchybnostClient,
} from '../../../client/external/evidencnaaplikacia/obalMaterialuNrSrBezchybnostClient';

interface ObalMaterialuProps {
  materialDetail: LegislativnyMaterialDetail,
  type: string,
  year: number,
  index: number,
}

const ObalMaterialuNrSrZaBezchybnostWrapper = ({
  materialDetail, type, year, index,
}: ObalMaterialuProps): ReactElement => {
  const {
    obalInitData,
    initDataStatus,
  } = useObalMaterialuNrSrZaBezchybnostInitData(type, year, index);

  const {
    wrapClient: fillSystemDataClient,
    status: fillSystemDataStatus,
    data: fillSystemData,
  } = useClient(fetchObalMaterialuNrSrZaBezchybnostInitData);

  const {
    wrapClient: createObalMaterialuNrSrBezchybnost,
  } = useClient(createObalMaterialuNrSrBezchybnostClient);

  return (
    <Loader loading={initDataStatus.loading || fillSystemDataStatus.loading}>
      {obalInitData && (
        <ObalMaterialuNrSrBezchybnost
          material={materialDetail}
          initFormData={obalInitData}
          onSubmitForm={createObalMaterialuNrSrBezchybnost}
          fillSystemDataClient={fillSystemDataClient}
          fillSystemDataStatus={fillSystemDataStatus}
          fillSystemData={fillSystemData}
        />
      )}
    </Loader>
  );
};

export default ObalMaterialuNrSrZaBezchybnostWrapper;
